import { atQuery } from '../../scripts/components/mediaQueries';

document.addEventListener('DOMContentLoaded', function () {
  [].forEach.call(document.querySelectorAll('.carousel-banner'), function (el, slidesPerViewLg) {
    window.dAgency.initCarouselBanner(el, slidesPerViewLg);
  })
});

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarouselBanner = (context, slidesPerViewLg) => {
  const carousel_banner = context.closest('.shopify-section');

  if (carousel_banner) {
    const slider = context.querySelector('.swiper');

    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: slidesPerViewLg || 3,
        }
      },
      navigation: {
        nextEl: carousel_banner.querySelector('.swiper-button-next'),
        prevEl: carousel_banner.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: carousel_banner.querySelector('.swiper-scrollbar'),
        draggable: true
      }
    });

    const slides = context.querySelectorAll('.swiper-slide');
    const maxSlides = 10;

    atQuery('max', 'lg', () => {
      if (slides.length > maxSlides) {
        for (let i = maxSlides; i < slides.length; i++) {
          slides[i].remove();
        }
      }
    });
  };
}
